import { FC, useCallback, useState } from 'react';
import { ActionItem } from './ActionItem';
import { ActionsPropsType } from './TypeProps';
import { SubscriptionBasket } from '@app/features/subscription';
import { getUniqueObjects } from '@sharedHelpers/getUniqueObjects';
import ClassNames from 'classnames';

import styles from './Actions.module.scss';

export const ActionsBlock: FC<ActionsPropsType> = ({ actions, rn, part, allQuantity, className }): JSX.Element => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const handlerBackData = useCallback(
    data => {
      data && setIsLoaded(true);
    },
    [rn],
  );

  const uniqueActions = getUniqueObjects(actions, 'code');

  return (
    <div className={ClassNames(styles.Container, !actions?.length && !isLoaded && styles.Hide, className)}>
      <ul className={ClassNames(styles.list, { [styles.FullWidth]: actions?.length === 1 && !isLoaded })}>
        <SubscriptionBasket rn={rn} part={part} allQuantity={allQuantity} handlerBackData={handlerBackData} />
        {uniqueActions?.map(action => <ActionItem newWindow={true} key={action?.id || action?.rn} {...action} />)}
      </ul>
    </div>
  );
};
